export async function freelanceInvoiceStore(action, value) {
  const db = await new Promise((resolve, reject) => {
    const request = indexedDB.open("jm-freelance-invoices", 1);
    request.onupgradeneeded = () =>
      request.result.createObjectStore("invoices", { keyPath: "id" });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(
      "invoices",
      action === "list" ? "readonly" : "readwrite",
    );
    const store = transaction.objectStore("invoices");
    const request =
      action === "list"
        ? store.getAll()
        : action === "delete"
          ? store.delete(value)
          : store.put(value);
    transaction.oncomplete = () => {
      db.close();
      resolve(
        action === "list"
          ? request.result.filter((row) => row.scope === value)
          : value,
      );
    };
    transaction.onerror = transaction.onabort = () => {
      db.close();
      reject(transaction.error);
    };
  });
}
